import { render, staticRenderFns } from "./CollectionOptionType.vue?vue&type=template&id=91690468&scoped=true&"
import script from "./CollectionOptionType.vue?vue&type=script&lang=js&"
export * from "./CollectionOptionType.vue?vue&type=script&lang=js&"
import style0 from "./CollectionOptionType.vue?vue&type=style&index=0&id=91690468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91690468",
  null
  
)

export default component.exports